import React, { Suspense } from 'react';
import { AppBar, Dialog, Paper, Toolbar, Typography, ScopedCssBaseline } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { observer } from 'mobx-react';
import { getEnv } from 'mobx-state-tree';
var useStyles = makeStyles()({
  paper: {
    overflow: 'auto'
  }
});
var ModalWidgetContents = observer(function (_ref) {
  var session = _ref.session;
  var visibleWidget = session.visibleWidget;
  if (!visibleWidget) {
    return React.createElement(AppBar, {
      position: "relative"
    }, React.createElement(Toolbar, null));
  }
  var _getEnv = getEnv(session),
    pluginManager = _getEnv.pluginManager;
  var _pluginManager$getWid = pluginManager.getWidgetType(visibleWidget.type),
    ReactComponent = _pluginManager$getWid.ReactComponent,
    HeadingComponent = _pluginManager$getWid.HeadingComponent,
    heading = _pluginManager$getWid.heading;
  var Component = visibleWidget ? pluginManager.evaluateExtensionPoint('Core-replaceWidget', ReactComponent, {
    session: session,
    model: visibleWidget
  }) : null;
  return React.createElement(React.Fragment, null, React.createElement(AppBar, {
    position: "static"
  }, React.createElement(Toolbar, null, HeadingComponent ? React.createElement(HeadingComponent, {
    model: visibleWidget
  }) : React.createElement(Typography, {
    variant: "h6"
  }, heading))), visibleWidget && Component ? React.createElement(Suspense, {
    fallback: React.createElement("div", null, "Loading...")
  }, React.createElement(ScopedCssBaseline, null, React.createElement(Component, {
    model: visibleWidget,
    session: session,
    overrideDimensions: {
      height: window.innerHeight * 5 / 8,
      width: 800
    }
  }))) : null);
});
var ModalWidget = observer(function (_ref2) {
  var session = _ref2.session;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var visibleWidget = session.visibleWidget,
    hideAllWidgets = session.hideAllWidgets;
  return React.createElement(Dialog, {
    open: Boolean(visibleWidget),
    onClose: hideAllWidgets,
    maxWidth: "xl"
  }, React.createElement(Paper, {
    className: classes.paper
  }, React.createElement(ModalWidgetContents, {
    session: session
  })));
});
export default ModalWidget;